export default "__VITE_ASSET__CtcoRQCM__"